import { UploadDocumentJob } from '@domain/types';

export interface UploadDocumentsState {
  jobs: UploadDocumentJob[];
}

export const INITIAL_UPLOAD_DOCUMENTS_STATE: UploadDocumentsState = {
  jobs: [],
};
